<div class="products-container">

  <div class="w-100 flex-direction-row justify-content-between align-items-center">
    <h4 class="pc__title">Products / {{ isEditProductPage ? 'Edit' : 'Create' }}</h4>
    <button class="filled-button tall-button gap-5px" (click)="redirectToProducts()">
      <img src="assets/svg/plus-white.svg" alt="">
      Back to Products
    </button>
  </div>

  <ng-container [ngTemplateOutlet]="addProductTemplate"></ng-container>
</div>

<ng-template #addProductTemplate>
  <div class="pc__table mt-50px" #topOfForm>
    <div class="pc-table__title-container">
      <span class="pc-table__title">General information / Create new product</span>
    </div>

    <div class="pc__default-body-container">
      <form [formGroup]="addProductFormGroup" (ngSubmit)="onSubmitForm()">

        <div class="language_container">

          <mat-stepper [formGroup]="addProductFormGroup" #stepper class="w-100"
                       (selectionChange)="selectLanguage($event)">
            <mat-step [formGroup]="addProductFormGroup">
              <ng-template matStepLabel>HY</ng-template>

              <ng-container
                [ngTemplateOutlet]="productForm"
                [ngTemplateOutletContext]="{formGroup: addProductFormGroup}"
              ></ng-container>
            </mat-step>
            <mat-step [formGroup]="addProductFormGroup">
              <ng-template matStepLabel>RU</ng-template>

              <ng-container
                [ngTemplateOutlet]="productForm"
                [ngTemplateOutletContext]="{formGroup: addProductFormGroup}"
              ></ng-container>
            </mat-step>
            <mat-step [formGroup]="addProductFormGroup">
              <ng-template matStepLabel>EN</ng-template>

              <ng-container
                [ngTemplateOutlet]="productForm"
                [ngTemplateOutletContext]="{formGroup: addProductFormGroup}"
              ></ng-container>
            </mat-step>
          </mat-stepper>
        </div>

        <div class="pc__body_common">
          <div class="pc__input-container">
            <div class="flex-direction-column">
              <span class="pc__input-title">Product gallery</span>
              <span class="pc__input-subtitle">Add product gallery images (.png only)</span>
            </div>

            <div class="image-selection-container"
                 (dragover)="onDragOver($event)"
                 (drop)="onDrop($event, picturesInput)"
                 (click)="onClickDropFiles(picturesInput)">
              @if (!productGalleryUrls.length && !productToEdit?.imageUrls?.length) {
              <div class="flex-direction-column justify-content-center align-items-center">
                <span class="isc__inner_title">Drop files here to upload</span>
                <span class="isc__inner_subtitle">300px x 300px</span>
              </div>
              } @else {
              @if (productToEdit?.imageUrls?.length) {
                  @for (url of productToEdit!.imageUrls; track url) {
                    <div class="gallery-image-container" [style.background]="lastSelectedColor?.value">
                      <img [src]="getProductImageUrl(url)" class="product-image" alt="">
                      <img src="assets/svg/close.svg" alt="" class="close-icon"
                           (click)="onClickDeleteImageForEdit(url); $event.stopPropagation();">
                    </div>
                  }
                } @else {
                  @for (url of productGalleryUrls; track url) {
                    <div class="gallery-image-container" [style.background]="lastSelectedColor?.value">
                      <img [src]="url" class="product-image" alt="">
                      <img src="assets/svg/close.svg" alt="" class="close-icon"
                           (click)="onClickDeleteImage(url); $event.stopPropagation();">
                    </div>
                  }
                }
              }
            </div>
            <span class="pc__error-message"
                  [ngClass]="{'active': showImageSizeError}">File size should not exceed 3MB.</span>
            <input type="file" hidden accept="image/png" [multiple]="true" #picturesInput>
          </div>

          <div class="pc__input-container">
            <span class="pc__input-title">Colors</span>

            <div class="flex-direction-row">
              <div class="colors">
                @for (colorAttributeValue of colorAttributeValues; track colorAttributeValue) {
                <div class="color-container"
                  (click)="onClickColor(colorAttributeValue)"
                  [ngClass]="{'selected': isColorSelected(colorAttributeValue), 'white': colorAttributeValue.value ==
                '#FFFFFF'}">
                    <div class="color" [style.background]="colorAttributeValue.value"></div>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="flex-direction-row gap-20px">
            <div class="pc__input-container">
              <span class="pc__input-title">Price</span>

              <input type="text"
                     (keypress)="onKeyPress($event)"
                     [formControl]="getFormControlByName('price')"
                     [placeholder]="'Select product price (AMD)'"
                     class="pc__input">

              <span class="pc__error-message" [ngClass]="{'active': priceErrorMessage}">{{ priceErrorMessage }}</span>
            </div>

            <div class="pc__input-container">
              <span class="pc__input-title">Visibility</span>

              <app-toggle
                inputId="visibility_toggle"
                [data]="ToggleElModel.create(
              {
                id: 1,
                selected: isVisibilityActive
              }
            )"
                (onChange)="updateAvailabilityInForm($event)"
              ></app-toggle>
            </div>

          </div>

          <div class="flex-direction-row justify-content-end gap-10px pc__buttons-container">
            <button (click)="redirectToProducts()"
                    class="filled-white-button short-button">Cancel
            </button>
            <button type="submit" [disabled]="isSaveButtonDisabled"
                    class="filled-button short-button">Save
            </button>
          </div>
        </div>

      </form>

    </div>
  </div>
</ng-template>

<ng-template #productForm let-formGroup="formGroup">
  <div class="pc__body">
    <div class="pc__input-container">
      <span class="pc__input-title">{{ getNameWithCurrentLanguage('Product title') }}</span>
      <input type="text"
             [formControl]="getFormControlNameByNameAndCurrentLang('productName')"
             [placeholder]="'Enter product title'" class="pc__input">
      <span class="pc__error-message"
            [ngClass]="{'active': productNameErrorMessage}">{{ productNameErrorMessage }}</span>
    </div>

    <div class="pc__input-container">
      <span class="pc__input-title">{{ getNameWithCurrentLanguage('Description') }}</span>
      <ckeditor [editor]="CK_EDITOR" [config]="CK_EDITOR_CONFIG"
                [formControl]="getFormControlNameByNameAndCurrentLang('productDescription')"></ckeditor>
      <span class="pc__error-message"
            [ngClass]="{'active': descriptionErrorMessage}">{{ descriptionErrorMessage }}</span>
    </div>

    <div class="pc__input-container">
      <span class="pc__input-title">{{ getNameWithCurrentLanguage('Compatibility description') }}</span>
      <ckeditor [editor]="CK_EDITOR" [config]="CK_EDITOR_CONFIG"
                [formControl]="getFormControlNameByNameAndCurrentLang('compatibilityDescription')"></ckeditor>
      <span class="pc__error-message"
            [ngClass]="{'active': compatibilityDescriptionErrorMessage}">{{ compatibilityDescriptionErrorMessage }}</span>
    </div>
  </div>
</ng-template>
